import { css, cx } from '@emotion/css';
import Button, { Variations as ButtonVariations } from 'components/Button';
import { Color } from 'css/theme';
import Image from 'next/future/image';
import * as React from 'react';

import GiftReminderWrapper from './GiftReminderWrapper';
import { useRemindersContext } from './context';
import { ModalState } from 'pages/reminders/reminders';
import { generateUniqueReminderId } from 'utils/reminder';

const text = css({
  fontSize: '24px',
  lineHeight: '28px',
});

const emptyBoardContainer = css({
  backgroundColor: Color.White,
  paddingTop: '32px',
  paddingBottom: '32px',
  boxShadow: '0px 10px 30px rgba(209, 213, 223, 0.5)',
  borderRadius: '10px',
  paddingLeft: '2em',
  paddingRight: '2em',
  textAlign: 'center',
  '@media (min-width: 768px)': {
    marginRight: '1.875rem',
  },
});

const buttonWrapper = css({
  width: '190px',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '24px',
});

const GiftReminderEmptyDashboard = () => {
  const { setModalState, setReminderInstanceId } = useRemindersContext();
  return (
    <GiftReminderWrapper>
      <div className={emptyBoardContainer}>
        <Image src="/images/icon_bells.svg" alt="Bells icon" width={55} height={55} />
        <h3 className={cx(text, 'set-reminder-title')}>
          Set a reminder to ensure you never miss a birthday or anniversary again!
        </h3>
        <div className={buttonWrapper}>
          <Button
            className="create-reminder-button"
            type="button"
            variation={ButtonVariations.Primary}
            onClick={() => {
              setReminderInstanceId(generateUniqueReminderId());
              setModalState({ state: ModalState.New });
            }}
          >
            Create a reminder
          </Button>
        </div>
      </div>
    </GiftReminderWrapper>
  );
};

export default GiftReminderEmptyDashboard;
